module.exports = __webpack_public_path__ + "static/media/Education - Alzheimer.82e589ef.svg";